module.exports = __webpack_public_path__ + "static/media/data_scientist.48fa6228.png";